<div class="container" style="padding: 20px;">

    <!-- A global toggle that disables or enables everything -->
<!--    <mat-slide-toggle [(ngModel)]="globalDisabled" style="margin-bottom: 20px;">-->
<!--        Disable All-->
<!--    </mat-slide-toggle>-->

    <!-- Radio group for choosing which section is active -->

    <div>
        <button color="warn" mat-raised-button (click)="openDir()">show directory</button>
    </div>
    <br/>
    <mat-radio-group [(ngModel)]="selectedOption">

        <!-- SECTION 1 -->
        <div style="position: relative; padding: 20px; border: 2px black dashed; margin-bottom: 30px;">
            <!-- Radio button for SECTION 1 -->
            <mat-radio-button
                    style="position: absolute; top: 10px; left: 10px;"
                    value="textOption"
                    [disabled]="globalDisabled"
            >
                Use text-to-speech
            </mat-radio-button>

            <!-- Actual content for SECTION 1 -->
            <div style="margin-top: 40px;">
                <mat-form-field
                        style="width: 100%; height: 300px"
                        appearance="fill"
                        class="my-custom-textarea"
                >
                    <mat-label>Paste text here</mat-label>
                    <textarea
                            matInput
                            rows="8"
                            [(ngModel)]="data"
                            [disabled]="globalDisabled || selectedOption !== 'textOption'"
                    ></textarea>
                </mat-form-field>
                <br />
                <button
                        mat-raised-button
                        (click)="onCreateTTS()"
                        [disabled]="globalDisabled || selectedOption !== 'textOption' || disabledButtonCreate"
                >
                    test text-to-speech
                </button>
            </div>
        </div>

        <!-- SECTION 2 -->
        <div style="position: relative; padding: 20px; border: 2px black dashed;">
            <!-- Radio button for SECTION 2 -->
            <mat-radio-button
                    style="position: absolute; top: 10px; left: 10px;"
                    value="finalOption"
                    [disabled]="globalDisabled"
            >
                Produce final version
            </mat-radio-button>

            <!-- Actual content for SECTION 2 -->
            <div style="margin-top: 40px; display: flex; align-items: center; gap: 16px;">
                <mat-label>Produce final version and upload?</mat-label>

                <mat-form-field appearance="fill">
                    <mat-label>download url</mat-label>
                    <input
                            matInput
                            autocomplete="off"
                            [(ngModel)]="downloadUrl"
                            [disabled]="globalDisabled || selectedOption !== 'finalOption'"
                            matTooltip="http://www..."
                    />
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>password</mat-label>
                    <input
                            matInput
                            autocomplete="off"
                            [(ngModel)]="password"
                            type="text"
                            [disabled]="globalDisabled || selectedOption !== 'finalOption'"
                    />
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>video name</mat-label>
                    <input
                            matInput
                            autocomplete="off"
                            [(ngModel)]="videoName"
                            type="text"
                            [disabled]="globalDisabled || selectedOption !== 'finalOption'"
                    />
                </mat-form-field>

                <button
                        mat-raised-button
                        (click)="onUploadTTS()"
                        [disabled]="globalDisabled || selectedOption !== 'finalOption' || disabledButtonUpload"
                >
                    Upload final version
                </button>
            </div>
        </div>

    </mat-radio-group>
</div>
